export const LICENSE_OPTIONS = ['B', 'BE', 'C1', 'C1E', 'C', 'CE', 'D1', 'D1E', 'D', 'DE', 'L', 'T'];

export const STATUS_MAP = {
    present: { label: 'Anwesend', badge: 'green', dot: 'active', color: '#34c759', type: 'present' },
    urlaub: { label: 'Urlaub', badge: 'blue', dot: 'absent', color: '#007aff', type: 'urlaub' },
    krank: { label: 'Krankheit', badge: 'red', dot: 'absent', color: '#ff3b30', type: 'krank' },
    termin: { label: 'Termin', badge: 'orange', dot: 'busy', color: '#ff9500', type: 'termin' },
    sonstiges: { label: 'Sonstiges', badge: 'purple', dot: 'busy', color: '#af52de', type: 'sonstiges' }
};

export const RESOURCE_PALETTE = [
    { label: 'Azure', hex: '#007aff' },
    { label: 'Indigo', hex: '#5856d6' },
    { label: 'Purple', hex: '#af52de' },
    { label: 'Pink', hex: '#ff2d55' },
    { label: 'Orange', hex: '#ff9500' },
    { label: 'Green', hex: '#34c759' },
    { label: 'Teal', hex: '#5ac8fa' },
    { label: 'Rose', hex: '#ff6482' },
    { label: 'Cyan', hex: '#30b0c7' }
];
